// Reducer.js
import { isPresentInFavorites } from '../../config/logic';
import {
    ADD_TO_FAVORITE_FAILURE, ADD_TO_FAVORITE_REQUEST, ADD_TO_FAVORITE_SUCCESS,
    GET_USER_FAILURE, GET_USER_REQUEST, LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS,
    REGISTER_FAILURE, REGISTER_REQUEST, REGISTER_SUCCESS, LOGOUT,
    GET_USER_SUCCESS,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE
  } from './ActionTypes';
  
  const initialState = {
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    message: '',
    jwt: localStorage.getItem('jwt') || null,
    favorites: [],
    success: null,
  };
  
  export const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case REGISTER_REQUEST:
      case LOGIN_REQUEST:
      case GET_USER_REQUEST:
      case ADD_TO_FAVORITE_REQUEST:
        return { ...state, isLoading: true, error: null, success: null };
      
      case REGISTER_SUCCESS:
      case LOGIN_SUCCESS:
        return { ...state, isLoading: false, jwt: action.payload, success: 'Register success' , isAuthenticated: true};

        case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

      case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload, // Update with success message
        error: null,
      };

      case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


      case GET_USER_SUCCESS:
        return { ...state, isLoading: false, user: action.payload, favorites:action.payload.favorites };
      
      case ADD_TO_FAVORITE_SUCCESS:
        return {
          ...state,
          isLoading: false,
          error: null,
          favorites: isPresentInFavorites(state.favorites, action.payload)
            ? state.favorites.filter((item) => item.id !== action.payload.id)
            : [action.payload, ...state.favorites],
        };
      
      case REGISTER_FAILURE:
      case LOGIN_FAILURE:
      case GET_USER_FAILURE:
      case ADD_TO_FAVORITE_FAILURE:
        return { ...state, isLoading: false, error: action.payload };
      
      case LOGOUT:
        return initialState;
      
      default:
        return state;
    };

  };
  